import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { TickCircle } from '@r1-frontend/ui-react/components/svg/main';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const PopupWrapper = styled.div`
    padding: 32px;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: space-between;
`;

export const PopupSuccessIcon = styled(TickCircle)`
    #contour,
    #guts {
        stroke: ${COLORS.Success};
    }
`;

export const PopupErrorIcon = styled.i`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 7px;
    border: 1.5px solid ${COLORS.Locked};
    border-radius: 50%;

    & > svg {
        #guts {
            stroke: ${COLORS.Locked};
        }
    }
`;

export const PopupTitle = styled.div`
    width: 100%;
    color: ${COLORS.TextPrimary};
    ${FONTS.H3};
    margin: 16px 0;
    max-width: 500px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        max-width: 300px;
    }

    @media (max-width: ${wideBreakpoints.sMobile}) {
        max-width: 200px;
    }    
`;

export const PopupText = styled.div`
    ${FONTS.MediumS};
    color: ${COLORS.TextInfo};
    margin-bottom: 16px;
`;

export const PopupButtonsWrapper = styled.div`
    justify-content: start;
    gap: 12px;
    width: 100%;

    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-direction: column;
    }
`;
